import type {ReactElement} from 'react';
import './circular-progress-loader.scss';

export enum LOADER_SIZE {
  DEFAULT = 'default',
  SMALL = '-small',
  XXXSMALL = '-xxxsmall',
  XXSMALL = '-xxsmall',
  XSMALL = '-xsmall',
  MEDIUM = '-medium',
  LARGE = '-large',
}

export enum LOADER_COLOR {
  PRIMARY_DARK = '-primarydark',
  PRIMARY = '-primary',
  WHITE = '-white',
  DARK = '-dark',
  ERROR = '-error',
  SUCCESS = '-success',
  WARNING = '-warning',
  AI_DARK = '-aidark',
  AI = '-ai',
}

interface CircularProgressLoaderProps {
  /**
   * adjusts the width/height of the loader
   */
  size?: LOADER_SIZE;
  /**
   * changes the stroke-color of the loader
   */
  color?: LOADER_COLOR;
  /**
   * extra classes
   */
  classes?: string;
}

export function CircularProgressLoader({size = LOADER_SIZE.DEFAULT, color = LOADER_COLOR.PRIMARY, classes = ''}: CircularProgressLoaderProps): ReactElement<any> {
  return <progress className={`icon-circular-loader ${classes} ${size} ${color}`} />;
}
